import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Link from '@material-ui/core/Link';
import Container from '@material-ui/core/Container';
import Typography from '../components/Typography';
import TextField from '../components/TextField';

function Copyright() {
  return (
    <React.Fragment>
      {'© '}
      <Link color="inherit" href="/">
        Barokah Group
      </Link>{'   '}
      {new Date().getFullYear()}
    </React.Fragment>
  );
}

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    backgroundColor: theme.palette.secondary.light,
  },
  container: {
    marginTop: theme.spacing(8),
    marginBottom: theme.spacing(8),
    display: 'flex',
  },
  iconsWrapper: {
    height: 150,
  },
  icons: {
    display: 'flex',
  },
  icon: {
    width: 48,
    height: 48,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: theme.palette.warning.main,
    marginRight: theme.spacing(1),
    '&:hover': {
      backgroundColor: theme.palette.warning.dark,
    },
  },
  list: {
    margin: 0,
    listStyle: 'none',
    paddingLeft: 0,
  },
  listItem: {
    paddingTop: theme.spacing(0.5),
    paddingBottom: theme.spacing(0.5),
  },
  language: {
    marginTop: theme.spacing(1),
    width: 150,
  },
}));

/*
const LANGUAGES = [
  {
    code: 'in-IN',
    name: 'Indonesia',
  },
  {
    code: 'en-US',
    name: 'English',
  },
];*/

export default function AppFooter(props) {
  const classes = useStyles();
  const {language,LANGUAGES} = props
  return (
    <Typography component="footer" className={classes.root}>
      <Container className={classes.container}>
        <Grid container spacing={5}>
          <Grid item xs={6} sm={6} md={3}>
            <Grid
              container
              direction="column"
              justify="center"
              alignItems="flex-start"
              className={classes.iconsWrapper}
              spacing={2}
            >
              <Grid item className={classes.icons} >
                <a href="https://www.facebook.com/" className={classes.icon}>
                  <img src="/static/appFooterFacebook.png" alt="Facebook" />
                </a>
                <a href="https://www.twitter.com" className={classes.icon}>
                  <img src="/static/appFooterTwitter.png" alt="Twitter" />
                </a>
              </Grid>
              <Grid item >
                <Copyright />
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={6} sm={4} md={2}>
            <Typography variant="h6" marked="left" gutterBottom>
              {language==="en-US"?"Legal":"Hukum"}
            </Typography>
            <ul className={classes.list}>
              <li className={classes.listItem}>
                <Link href="/terms">{language==="en-US"?"Terms":"Ketentuan"}</Link>
              </li>
              <li className={classes.listItem}>
                <Link href="/privacy">{language==="en-US"?"Privacy":"Privasi"}</Link>
              </li>
            </ul>
          </Grid>
          <Grid item xs={12} sm={8} md={4}>
            <Typography variant="h6" marked="left" gutterBottom>
              {language==="en-US"?"Language":"Bahasa"}
            </Typography>
            <TextField
              select
              SelectProps={{
                native: true,
              }}
              className={classes.language}
              onChange={!!props.onLanguageChange?props.onLanguageChange:null}
            >
              {LANGUAGES.map(language => (
                <option value={language.code} key={language.code}>
                  {language.name}
                </option>
              ))}
            </TextField>
          </Grid>
          <Grid item>
            <Typography variant="caption">
              {language==="en-US"?"Icons made by ":"Ikon dibuat oleh "}
              <Link href="https://www.freepik.com" rel="nofollow" title="Freepik">
                Freepik
              </Link>
              {' from '}
              <Link href="https://www.flaticon.com" rel="nofollow" title="Flaticon">
                www.flaticon.com
              </Link>
              {' is licensed by '}
              <Link
                href="https://creativecommons.org/licenses/by/3.0/"
                title="Creative Commons BY 3.0"
                target="_blank"
                rel="noopener noreferrer"
              >
                CC 3.0 BY
              </Link>
            </Typography>
          </Grid>
        </Grid>
      </Container>
    </Typography>
  );
}